import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory, Link } from 'react-router-dom';
import AdminMenuWrapper from '@admin/nav_menu/AdminMenuWrapper';
import { Switcher, BasicButton, BasicText } from '@components';
import LoadingWrapper from '@components/LoadingWrapper';
import OverallStats from '@users/OverallStats';
import DownloadEmails from '@users/DownloadEmails';
import UserTable from '@users/UserTable';
import { getAPIRequest, setRecentlyDeleted } from '@actions';
import styles from './UserHome.module.css';
import { Input, Space } from 'antd';

const { Search } = Input;

let _searchTimeout = null;

const UserHome = ({ getAPIRequest, recentlyDeletedId, setRecentlyDeleted }) => {
  const [isSearching, setIsSearching] = useState(false);
  const [overallData, setOverallData] = useState({});
  const [users, setUsers] = useState([]);
  const [seenIds, setSeenIds] = useState([]);
  const [searchUsers, setSearchUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [isMore, setIsMore] = useState(true);
  const [isFetchingMore, setIsFetchingMore] = useState(false);

  console.log(users.length);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (recentlyDeletedId != null) {
      fetchData();
      performSearch();
      setRecentlyDeleted(null);
    }
  }, [recentlyDeletedId]);

  const fetchData = () => {
    getAPIRequest(
      '/admin/get_user_data',
      {},
      response => {
        setUsers(response.users);
        setSeenIds(response.users.map((u) => u.id));
        setOverallData(response.overall_stats);
        setIsLoading(false);
      },
      error => {
        //onFail(error.error);
      },
    )
  };

  const performSearch = () => {
    const currentSearchTerm = searchTerm;
    if (currentSearchTerm.length > 0) {
      getAPIRequest(
        '/admin/search_users',
        { query: currentSearchTerm },
        response => {
          if (currentSearchTerm === searchTerm) {
            setSearchUsers(response.users);
          }
        },
        error => {
          //onFail(error.error);
        },
      );
    }
  }

  useEffect(() => {
    clearTimeout(_searchTimeout);
    if (searchTerm.length > 0) {
      _searchTimeout = setTimeout(() => performSearch(), 500);
    }
  }, [searchTerm]);

  const fetchMoreUsers = () => {
    setIsFetchingMore(true);
    getAPIRequest(
      '/admin/fetch_more_users',
      { seen_ids: seenIds },
      response => {
        const newUsers = response.users;
        setIsFetchingMore(false);
        setIsMore(newUsers.length > 0);
        setUsers(users.concat(newUsers));
        setSeenIds(seenIds.concat(newUsers.map((u) => u.id)));
      },
      error => {
        //onFail(error.error);
      },
    )
  };

  return (
    <LoadingWrapper isLoading={isLoading} loadingText="Fetching User Data" size="large">
      <div className={styles.user_container_style}>
        <OverallStats overallData={overallData} />
        <div style={{ padding: 20, display: "flex" }}>
          <Search
            allowClear
            placeholder="Search Users..."
            onChange={(e) => setSearchTerm(e.target.value)}
            value={searchTerm}
            style={{ width: 360 }}
          />

          <div style={{ marginLeft: 20 }}>
            <DownloadEmails />
          </div>
        </div>

        <UserTable
          users={searchTerm.length > 0 ? searchUsers : users}
        />

        {isMore && searchTerm.length === 0 &&
          <BasicButton
            text="Load More Users"
            type="primary"
            style={{ marginLeft: "20px", marginTop: "12px", marginBottom: "20px" }}
            loading={isFetchingMore}
            onClick={() => fetchMoreUsers()}
          />
        }
      </div>
    </LoadingWrapper>
  );
};

const mapStatesToProps = (state) => {
  const { recentlyDeletedId } = state.admin;
  return { recentlyDeletedId };
};

export default connect(mapStatesToProps, {
  getAPIRequest,
  setRecentlyDeleted
})(UserHome);
